module.exports = __webpack_public_path__ + "static/media/search-icon-dark.a1d558f5.svg";